module.exports = __webpack_public_path__ + "img/gen-space-map.ad871e46.svg";